import React from 'react';

import FormManager from '@/Shared/form/FormManager'
import { InputGroup, Button, Image, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSearch, faTimes} from '@fortawesome/free-solid-svg-icons'
import {useProps} from '@/Shared/FuncComp'
import Link from '@/Shared/Link'
import classNames from 'classnames'; 

const ContentItem = ({children, ...props}) => {
	const {manager, searchManager} = props;
	//const {Item} = manager;
	const tipo = (props.idx||"").split("-")[0].toLowerCase();
	let href;
	switch (tipo) {
		case 'pro':
			href = route('productos.show', props.id);
			break;
		case 'subcat':
			href = route('cartera.productos.index', props.id);
			break;
	}
	const onClick = (e) => {
		console.log('clicked!');
		searchManager.setDefaults();;
	}
	return <>
		{props.photo && <Image src={props.photo} className="mr-3" alt={children} />}
		<Link href={href} onClick={onClick} className={"stretched-link text-break text-wrap"+(props.photo?"":" my-3")}>{children||props.name}</Link>
	</>
}


const CompSearch = (props) => {
	const {hot_search} = useProps();
	const {manager} = props;
	const {searchProps={}, btnProps, setShowSearcher, isShowSearcher} = manager.props;
	// if (!isShowSearcher) searchProps.className = ("d-none")+(searchProps.className?' '+searchProps.className:"");
	const searcherRef = React.useRef();
	const searcherBtn = <Button variant="outline-primary" {...btnProps} onClick={()=>{
		// if (isShowSearcher) manager.setValues({'searcherNav': {input: "", val: undefined}});
		// setShowSearcher((p)=>!p)
		searcherRef.current?.focus();
	}}>
		<FontAwesomeIcon icon={isShowSearcher ? faTimes : faSearch} />
	</Button>
	return <manager.Form className="p-0">
		<InputGroup className="">
			<InputGroup.Prepend>
				{searcherBtn}
			</InputGroup.Prepend>
			{manager.control({
				// 	controlId: "searcherNav", as: Row, className: "align-items-center mb-0 pr-3", 
				// }, {
				// 	children: "Buscando: ", className: "mb-0"+(!isShowSearcher?" d-none":""),
				// }, {
					ref: searcherRef,
					name: "searcherNav",
					type: "list", 
					placeholder: 'Escriba aquí el producto o marca que desea buscar',
					// className: !isShowSearcher?"d-none":undefined,
					...searchProps,
					generalProps: {list: hot_search, keyVal: "idx", keyCnt: "name", 
						searchParam: 'q', onlySearch: ['hot_search'], noSelectable: true,
						noToggle: true, ceroInnerEmpty: 'Escribe para buscar',
						searchOnShow: true, noSearchEmptyOnShow: true,
						content: ContentItem,
						dropdownProps: {
							className: isShowSearcher?'col pr-0':undefined,
						},
						customProps: ({item, pos}) => {
							const tipo = (item.idx||"").split("-")[0].toLowerCase();
							const className = classNames("position-relative d-flex align-items-center", {
								'border-top': !!pos
							});
							return {
								itemProps: {className, style: {
									...(tipo=="pro"?{borderLeftWidth: 3, borderColor: "var(--primary)"}:null)
								}},
								...item,
								pos,
								searchManager: manager,
							}
						},
						dropdownAppend: manager.inputValues('searcherNav')?<Button variant="outline-primary" {...btnProps} onClick={()=>{
							manager.setValues({'searcherNav': {input: "", val: undefined}});
							// setShowSearcher((p)=>!p)
							// searcherRef.current?.focus();
						}}>
							<FontAwesomeIcon icon={faTimes} />
						</Button> : undefined,
						...searchProps?.generalProps
					},
			})}
			{/*<InputGroup.Append>
				<Button variant="outline-primary" {...btnProps}>
					<FontAwesomeIcon icon={faSearch} />
				</Button>
			</InputGroup.Append>*/}
		</InputGroup>
	</manager.Form>
}

export default function SearcherHeader({searchProps, btnProps, ...props}) {
	return <FormManager 
		method="GET"
		btnProps={btnProps}
		searchProps={searchProps}
		component={CompSearch}
		setShowSearcher={props.setShow}
		isShowSearcher={props.show}
		{...props}
	/>
}
